import { MatTableDataSource } from '@angular/material/table';
import { UserRole } from '@core/models';

export class CustomSortingTableDataSource<T> extends MatTableDataSource<T> {
  constructor(data: T[] = []) {
    super(data);

    this.sortingDataAccessor = (item: T, property: string): string | number => {
      const value = item[property as keyof T];

      switch (true) {
        case property === 'categories' && Array.isArray(value):
          return typeof value[0]?.name === 'string' ? value[0].name.toLowerCase() : 'z';
        case property === 'departments' && Array.isArray(value):
          if ((item as any)?.all_departments_access) {
            return 'all_departments';
          }
          return typeof value[0]?.name === 'string' ? value[0].name.toLowerCase() : 'z';
        case property === 'role' && typeof value === 'object':
          return (value as UserRole)?.name?.toLowerCase() || 'z';
        case property === 'foreign_keys' && Array.isArray(value):
          return value.length;
        case typeof value === 'boolean':
          return value ? 1 : 0;
        case typeof value === 'string':
          return value.toLowerCase();
        case typeof value === 'number':
          return value;
        case value instanceof Date:
          return value.getTime();
        case value === null || value === undefined:
          return 'z';
        default:
          return 'z';
      }
    };
  }
}
